import { TasksTable } from "@/features/tasks/tasks-table";

const TasksScreen = () => {
  return (
    <div className="p-4">
      <TasksTable />
    </div>
  );
};

export default TasksScreen;
